import ShapeTypeEnum from "./ShapeTypeEnum";

export default class Representation2d  {
    
    shapeType: ShapeTypeEnum = ShapeTypeEnum.NotDefined;
    materialId: number | null;
    
    constructor(shapeType: ShapeTypeEnum, materialId: number | null) {
        this.shapeType = shapeType;
        this.materialId = materialId;
    }
}